<template>
    <button :class="classes" @click="$emit('click')">
        <span class="button-label">{{ label }}</span>
    </button>
</template>

<script>
  import BaseButton from './BaseButton';

  export default {
    name: 'TextButton',

    extends: BaseButton,

    props: {

      label: {
        type:     String,
        required: true,
      },
    },

    computed: {
      classes () {
        return {
          ...this.baseClasses,
          'text-button': true,
        };
      },
    },
  };
</script>

<style scoped>
    .text-button {
        display:         flex;
        justify-content: space-between;
        align-items:     center;
    }
</style>
